<template>
  <div>
    <v-form v-model="validFormIbsCbs" ref="validFormIbsCbs" lazy-validation>
      <Row class="mt-5">
        <Col md="6">
          <TextField v-model="model.ibscbs_cst"
            :placeholder="l.cst.placeholder"
            :label="l.cst.label"
            :maxlength="3" :counter="3" />
        </Col>
        <Col md="6">
          <TextField v-model="model.ibscbs_c_class_trib"
            :placeholder="l.classTrib.placeholder"
            :label="l.classTrib.label"
            :maxlength="6" :counter="6" />
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <TextFieldPercent v-model="model.ibscbs_ibs_uf_aliquot"
            :placeholder="l.ibsUfAliquot.placeholder"
            :label="l.ibsUfAliquot.label" />
        </Col>
        <Col md="4">
          <TextFieldPercent v-model="model.ibscbs_ibs_mun_aliquot"
            :placeholder="l.ibsMunAliquot.placeholder"
            :label="l.ibsMunAliquot.label" />
        </Col>
        <Col md="4">
          <TextFieldPercent v-model="model.ibscbs_cbs_aliquot"
            :placeholder="l.cbsAliquot.placeholder"
            :label="l.cbsAliquot.label" />
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <CheckBox v-model="model.ibscbs_include_discounts"
            @setCheckBox="setCheckBox($event, 'ibscbs_include_discounts')"
            :label="l.includeDiscounts.label" class="mt-0"/>
        </Col>
        <Col md="4">
          <CheckBox v-model="model.ibscbs_include_expenses"
            @setCheckBox="setCheckBox($event, 'ibscbs_include_expenses')"
            :label="l.includeExpenses.label" class="mt-0"/>
        </Col>
        <Col md="4">
          <CheckBox v-model="model.ibscbs_include_freight"
            @setCheckBox="setCheckBox($event, 'ibscbs_include_freight')"
            :label="l.includeFreight.label" class="mt-0"/>
        </Col>
      </Row>
    </v-form>
  </div>
</template>

<script>
import {
  Row,
  Col,
  TextField,
  TextFieldPercent,
} from '@/components/vuetify';
import CheckBox from '@/components/vuetify/CheckBox';

export default {
  name: 'IbsCbs',
  components: {
    Row,
    Col,
    TextField,
    TextFieldPercent,
    CheckBox
  },
  props: {
    model: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
      validFormIbsCbs: false,
    };
  },
  computed: {
    l () {
      return this.$locales.pt.natureOperations.list.modalStates.modalCreateState.form.ibscbs;
    },
  },
  methods: {
    setCheckBox(value, type) {
      this.model[type] = value || false;
    }
  }
};
</script>
